/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faSquareFull } from '@fortawesome/pro-regular-svg-icons';
import { TaskDatumModel } from '../../../models/task.model';
import { LocationModel, RecordBaseModel, WorkflowItemType } from '../record-base.model';
const RECORD_PROP_ITEM_TYPE = 'itemType';
const RECORD_PROP_ITEM_NAME = 'itemName';
const RECORD_PROP_GEOLOCATION = 'geolocation';
const RECORD_PROP_TIMESTAMP = 'timestamp';
export class UnknownRecord extends RecordBaseModel {
  itemIcon: IconDefinition = faSquareFull;
  itemData?: Map<string, TaskDatumModel>;

  constructor(itemName: string, geolocation?: LocationModel, timestamp?: string) {
    super(itemName, WorkflowItemType.UNKNOWN, undefined, geolocation, timestamp);
  }

  fromJson(json: any): UnknownRecord | undefined {
    if (!json) return;
    let record = new UnknownRecord(
      json.itemName.value,
      LocationModel.fromJson(json.geolocation),
      json.timestamp?.value
    );
    if (!record.itemData) {
      record.itemData = new Map<string, TaskDatumModel>();
    }
    Object.entries(json as Map<string, any>).forEach(([key, value]) => {
      if (
        value['type'] != null &&
        key != RECORD_PROP_ITEM_TYPE &&
        key != RECORD_PROP_ITEM_NAME &&
        key != RECORD_PROP_GEOLOCATION &&
        key != RECORD_PROP_TIMESTAMP
      ) {
        let taskDatum = Object.create(TaskDatumModel.prototype);
        record.itemData?.set(key, taskDatum.fromJson(value));
      }
    });
    return record;
  }
}
